<template>
    <div v-if="isLoaded" class="content-wrapper assignments-conf">
        <div class="common-form no-print">
            <Transition name="slide-fade">
                <div
                    v-if="isLoaded && unsavedChanges && isVisibilityDecreased"
                    class="inline-window-info icon-allert"
                >
                    {{ $t('settings.assignmentsConfTab.hideExistingAssignments') }}
                </div>
            </Transition>
            <div>
                <div class="common-form-section">
                    <p class="common-form-title">{{ $t('settings.assignmentsConfTab.callCategories') }}</p>
                    <div class="wrapper-pattern">
                        <div class="chkbox inline">
                            <input
                                id="showResidentCall"
                                v-model="assignmentsConf.show_resident_call"
                                type="checkbox"
                                :class="{
                                    'checkbox-warning':
                                        !assignmentsConf.show_resident_call &&
                                        !assignmentsConf.show_staff_call &&
                                        isLoaded,
                                }"
                            />
                            <label for="showResidentCall"></label>
                            <label
                                for="showResidentCall"
                                :class="{
                                    'with-error':
                                        !assignmentsConf.show_resident_call &&
                                        !assignmentsConf.show_staff_call &&
                                        isLoaded,
                                }"
                            >
                                {{ $t('settings.assignmentsConfTab.showResidentCall') }}
                            </label>
                        </div>
                        <span
                            v-if="
                                !assignmentsConf.show_resident_call &&
                                    !assignmentsConf.show_staff_call &&
                                    isLoaded
                            "
                            class="tooltiptext"
                        >
                            {{ $t('settings.assignmentsConfTab.selectCheckbox') }}
                        </span>
                        <div class="inline-wrapper">
                            <div
                                class="input-with-insidelabel"
                                :class="{
                                    tooltiperror:
                                        assignmentsConf.show_resident_call &&
                                        $v.assignmentsConf.resident_call_name.$invalid,
                                }"
                            >
                                <input
                                    id="forAT_Normal-Call-Name"
                                    v-model="assignmentsConf.resident_call_name"
                                    :disabled="!assignmentsConf.show_resident_call"
                                    @input="$v.assignmentsConf.resident_call_name.$touch()"
                                />
                                <label for="forAT_Normal-Call-Name">{{
                                    $t('settings.assignmentsConfTab.residentCallName')
                                }}</label>
                                <span
                                    v-if="
                                        assignmentsConf.show_resident_call &&
                                            $v.assignmentsConf.resident_call_name.$invalid
                                    "
                                    class="tooltiptext"
                                >
                                    {{
                                        errorDisplay($v.assignmentsConf.resident_call_name, {
                                            val: MAX_CALL_NAME_LENGTH,
                                        })
                                    }}
                                </span>
                            </div>
                            <SelectBox
                                v-model="assignmentsConf.resident_color"
                                :options="assignmentsColors"
                                :search="false"
                                :is-disabled="!assignmentsConf.show_resident_call"
                                :placeholder="$t('settings.assignmentsConfTab.color')"
                            />
                        </div>
                    </div>

                    <div class="wrapper-pattern">
                        <div class="chkbox inline">
                            <input
                                id="showStaffCall"
                                v-model="assignmentsConf.show_staff_call"
                                type="checkbox"
                                :class="{
                                    'checkbox-warning':
                                        !assignmentsConf.show_resident_call &&
                                        !assignmentsConf.show_staff_call &&
                                        isLoaded,
                                }"
                            />
                            <label
                                for="showStaffCall"
                                :class="{
                                    'with-error':
                                        !assignmentsConf.show_resident_call &&
                                        !assignmentsConf.show_staff_call &&
                                        isLoaded,
                                }"
                            ></label>
                            <label
                                for="showStaffCall"
                                :class="{
                                    'with-error':
                                        !assignmentsConf.show_resident_call &&
                                        !assignmentsConf.show_staff_call &&
                                        isLoaded,
                                }"
                            >
                                {{ $t('settings.assignmentsConfTab.showStaffCall') }}
                            </label>
                        </div>
                        <span
                            v-if="
                                !assignmentsConf.show_resident_call &&
                                    !assignmentsConf.show_staff_call &&
                                    isLoaded
                            "
                            class="tooltiptext"
                        >
                            {{ $t('settings.assignmentsConfTab.selectCheckbox') }}
                        </span>
                        <div class="inline-wrapper">
                            <div
                                class="input-with-insidelabel"
                                :class="{
                                    tooltiperror:
                                        assignmentsConf.show_staff_call &&
                                        $v.assignmentsConf.staff_call_name.$invalid,
                                }"
                            >
                                <input
                                    id="forAT_Assistance-Call-Name"
                                    v-model="assignmentsConf.staff_call_name"
                                    :disabled="!assignmentsConf.show_staff_call"
                                    @input="$v.assignmentsConf.staff_call_name.$touch()"
                                />
                                <label for="forAT_Assistance-Call-Name">{{
                                    $t('settings.assignmentsConfTab.staffCallName')
                                }}</label>
                                <span
                                    v-if="
                                        assignmentsConf.show_staff_call &&
                                            $v.assignmentsConf.staff_call_name.$invalid
                                    "
                                    class="tooltiptext"
                                >
                                    {{
                                        errorDisplay($v.assignmentsConf.staff_call_name, {
                                            val: MAX_CALL_NAME_LENGTH,
                                        })
                                    }}
                                </span>
                            </div>
                            <SelectBox
                                v-model="assignmentsConf.staff_color"
                                :options="assignmentsColors"
                                :search="false"
                                :placeholder="$t('settings.assignmentsConfTab.color')"
                                :is-disabled="!assignmentsConf.show_staff_call"
                            />
                        </div>
                    </div>
                </div>

                <div class="common-form-section">
                    <div class="wrapper">
                        <p class="common-form-title">{{ $t('settings.assignmentsConfTab.typeAndLevel') }}</p>
                    </div>
                    <div class="wrapper">
                        <span v-if="$v.assignmentsConf.assignments_type.$invalid" class="tooltiptext">
                            {{ errorDisplay($v.assignmentsConf.assignments_type) }}
                        </span>
                        <SelectBox
                            v-model="assignmentsConf.assignments_type"
                            :placeholder="$t('settings.assignmentsConfTab.assignmentsType')"
                            :options="typeOptions"
                            :invalid="$v.assignmentsConf.assignments_type.$invalid"
                        />
                        <input
                            id="forAT_Assignments_Types"
                            v-model="assignmentsConf.assignments_type"
                            type="hidden"
                            name="deviceType"
                            @input="$v.assignmentsConf.assignments_type.touch()"
                        />
                    </div>
                    <div class="wrapper">
                        <span v-if="$v.assignmentsConf.assignments_level.$invalid" class="tooltiptext">
                            {{ errorDisplay($v.assignmentsConf.assignments_level) }}
                        </span>
                        <SelectBox
                            v-model="assignmentsConf.assignments_level"
                            :placeholder="$t('settings.assignmentsConfTab.assignmentsLevel')"
                            :options="levelOptions"
                            :invalid="$v.assignmentsConf.assignments_level.$invalid"
                        />
                        <input
                            id="forAT_Assignments_Levels"
                            v-model="assignmentsConf.assignments_level"
                            type="hidden"
                            name="deviceType"
                            @input="$v.assignmentsConf.assignments_level.touch()"
                        />
                    </div>
                </div>

                <div class="common-form-section">
                    <div class="wrapper">
                        <p class="common-form-title">
                            {{ $t('settings.assignmentsConfTab.catchNetVisibility') }}
                        </p>
                    </div>
                    <div class="wrapper-pattern">
                        <div class="chkbox">
                            <input
                                id="showCatchNet"
                                v-model="assignmentsConf.show_catch_net"
                                type="checkbox"
                            />
                            <label for="showCatchNet"></label>
                            <label for="showCatchNet">{{
                                $t('settings.assignmentsConfTab.showCatchNet')
                            }}</label>
                        </div>
                    </div>
                </div>
                <div class="common-form-section">
                    <div class="wrapper">
                        <p class="common-form-title">
                            {{ $t('settings.assignmentsConfTab.staffOverloadSetting') }}
                        </p>
                    </div>
                    <div class="wrapper-pattern">
                        <div class="staff-overload-form">
                            <label class="item-label-overload" for="forAT_Staff_overload_setting">
                                {{ $t('settings.assignmentsConfTab.staffOverloadLabel') }}
                            </label>
                            <div class="staff-overload-input">
                                <input
                                    id="forAT_Staff_overload_setting"
                                    v-model="assignmentsConf.staff_overload"
                                    v-numeric-only
                                    type="number"
                                    class="input-number-overload"
                                    :class="[
                                        'input-with-insidelabel',
                                        { tooltiperror: $v.assignmentsConf.staff_overload.$invalid },
                                    ]"
                                    @input="$v.assignmentsConf.staff_overload.$touch()"
                                />
                                <span v-if="$v.assignmentsConf.staff_overload.$invalid" class="tooltiptext">
                                    {{
                                        errorDisplay($v.assignmentsConf.staff_overload, {
                                            minValue: MIN_STAFF_OVERLOAD,
                                            maxValue: MAX_STAFF_OVERLOAD,
                                        })
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex';
import mappingState from '../common/mappingState';
import SelectBox from '../common/SelectBox.vue';
import {
    minimumLength,
    maximumCallNameLength,
    possibleAssignmentsTypes,
    possibleAssignmentsLevels,
    errorDisplay,
    staffOverloadRange,
} from '../../validators';
import { SUCCESS, MAX_CALL_NAME_LENGTH, MAX_STAFF_OVERLOAD, MIN_STAFF_OVERLOAD } from '../../constants';
import { resourceAssignmentsConf } from '../../api/resources';
import { getCancelToken } from '../../api';
import commonDirectives from '../common/commonDirectives';
import { ifIsNotCanceled } from '../common/helpers';

export default {
    components: {
        SelectBox,
    },

    mixins: [mappingState, commonDirectives],

    constants: {
        MAX_CALL_NAME_LENGTH,
        MAX_STAFF_OVERLOAD,
        MIN_STAFF_OVERLOAD,
    },

    data() {
        return {
            assignmentsConf: {},
            typeOptions: [
                {
                    value: 0,
                    name: this.$t('settings.assignmentsConfTab.typeOptions.directAndDuty'),
                },
                {
                    value: 1,
                    name: this.$t('settings.assignmentsConfTab.typeOptions.direct'),
                },
                {
                    value: 2,
                    name: this.$t('settings.assignmentsConfTab.typeOptions.duty'),
                },
            ],
            levelOptions: [
                {
                    value: 0,
                    name: this.$t('settings.assignmentsConfTab.levelOptions.one'),
                },
                {
                    value: 1,
                    name: this.$t('settings.assignmentsConfTab.levelOptions.two'),
                },
            ],
            assignmentsConfCopy: {},
            assignmentsColors: [
                {
                    name: this.$t('settings.assignmentsConfTab.orange'),
                    value: 1,
                    color: 'orange',
                },
                {
                    name: this.$t('settings.assignmentsConfTab.red'),
                    value: 2,
                    color: 'red',
                },
                {
                    name: this.$t('settings.assignmentsConfTab.blue'),
                    value: 3,
                    color: 'blue',
                },
                {
                    name: this.$t('settings.assignmentsConfTab.green'),
                    value: 4,
                    color: 'green',
                },
            ],
            cancelToken: getCancelToken(),
            isLoaded: false,
        };
    },

    computed: {
        ...mapState(['unsavedChanges']),

        /**
         * Checks whether assignments configuration is valid or not
         * @return {Boolean}
         */
        isConfigurationValid() {
            return (
                !(
                    this.assignmentsConf.show_resident_call &&
                    this.$v.assignmentsConf.resident_call_name.$invalid
                ) &&
                !(this.assignmentsConf.show_staff_call && this.$v.assignmentsConf.staff_call_name.$invalid) &&
                !this.$v.assignmentsConf.assignments_type.$invalid &&
                !this.$v.assignmentsConf.assignments_level.$invalid &&
                (this.assignmentsConf.show_resident_call || this.assignmentsConf.show_staff_call) &&
                !this.$v.assignmentsConf.staff_overload.$invalid
            );
        },

        /**
         * Checks difference between assignments configuration and copy of assignments configuration
         * Returns false if difference is in visibility increased
         * @returns {Boolean}
         */
        isVisibilityDecreased() {
            return (
                (!this.assignmentsConf.show_resident_call &&
                    this.assignmentsConfCopy.show_resident_call !==
                        this.assignmentsConf.show_resident_call) ||
                (!this.assignmentsConf.show_staff_call &&
                    this.assignmentsConfCopy.show_staff_call !== this.assignmentsConf.show_staff_call) ||
                (this.assignmentsConf.assignments_type !== 0 &&
                    this.assignmentsConfCopy.assignments_type !== this.assignmentsConf.assignments_type) ||
                (this.assignmentsConf.assignments_level !== 1 && this.assignmentsConfCopy.assignments_level)
            );
        },
    },

    watch: {
        assignmentsConf: {
            handler() {
                this.setUnsavedChanges(true);
            },
            deep: true,
        },
    },

    created() {
        this.setSaveUndoButtons({
            undo: this.undo.bind(this),
            save: this.save.bind(this),
            saveDisabled: () => !this.unsavedChanges || !this.isConfigurationValid,
            wasChanged: () => !this.unsavedChanges,
        });
        this.loadAssignmentsConf();
    },

    beforeDestroy() {
        this.cancelToken.cancel();
    },

    validations() {
        return {
            assignmentsConf: {
                resident_call_name: { minimumLength, maximumCallNameLength },
                staff_call_name: { minimumLength, maximumCallNameLength },
                assignments_type: { possibleAssignmentsTypes },
                assignments_level: { possibleAssignmentsLevels },
                staff_overload: { staffOverloadRange },
            },
        };
    },

    methods: {
        ...mapActions({
            setAssignmentsSettings: 'setAssignmentsSettings',
        }),
        errorDisplay,

        /**
         * Loads assignments configuration from database
         */
        loadAssignmentsConf() {
            this.showLoading(true);
            return resourceAssignmentsConf({
                cancelToken: this.cancelToken.token,
            })
                .then(response => response.data)
                .then(configuration => {
                    this.assignmentsConf = {
                        ...configuration,
                        staff_color: configuration.staff_color || 1,
                        resident_color: configuration.resident_color || 2,
                        staff_overload: configuration.staff_overload,
                    };
                    this.assignmentsConfCopy = { ...this.assignmentsConf };
                    this.setAssignmentsSettings(this.assignmentsConfCopy);
                })
                .catch(
                    ifIsNotCanceled({
                        callback: () => {
                            this.assignmentsConf = {
                                show_resident_call: true,
                                resident_call_name: 'Room',
                                resident_color: 2,
                                show_staff_call: true,
                                staff_call_name: 'Staff',
                                staff_color: 1,
                                assignments_type: 0,
                                assignments_level: 1,
                                show_catch_net: true,
                                staff_overload: 100,
                            };
                            this.assignmentsConfCopy = { ...this.assignmentsConf };
                        },
                    })
                )
                .then(response => {
                    if (response !== 'canceled') {
                        this.setUnsavedChanges(false);
                        this.showLoading(false);
                        this.isLoaded = true;
                    }
                });
        },

        /**
         * Prepares assignments configuration for saving.
         * Re-write call name by the previous call name if checkbox is unchecked.
         */
        prepareConfForSave() {
            if (!this.assignmentsConf.show_resident_call) {
                this.assignmentsConf.resident_call_name = this.assignmentsConfCopy.resident_call_name;
                this.assignmentsConf.resident_color = this.assignmentsConfCopy.resident_color;
            }
            if (!this.assignmentsConf.show_staff_call) {
                this.assignmentsConf.staff_call_name = this.assignmentsConfCopy.staff_call_name;
                this.assignmentsConf.staff_color = this.assignmentsConfCopy.staff_color;
            }
            this.assignmentsConf.resident_call_name = this.assignmentsConf.resident_call_name.trim();
            this.assignmentsConf.staff_call_name = this.assignmentsConf.staff_call_name.trim();
            this.assignmentsConf.staff_overload = parseInt(this.assignmentsConf.staff_overload);
        },

        /**
         * Sends assignments configuration into database
         */
        save() {
            if (this.unsavedChanges && this.isConfigurationValid) {
                this.showLoading(true);
                this.prepareConfForSave();
                return resourceAssignmentsConf({
                    method: 'post',
                    data: this.assignmentsConf,
                    cancelToken: this.cancelToken.token,
                })
                    .then(() => {
                        this.popup({
                            type: SUCCESS,
                            header: this.$t('common.success'),
                            text: this.$t('common.saved'),
                        });
                        this.showLoading(false);
                        this.setUnsavedChanges(false);
                        this.assignmentsConfCopy = { ...this.assignmentsConf };
                        this.setAssignmentsSettings(this.assignmentsConfCopy);
                    })
                    .catch(ifIsNotCanceled());
            }
        },

        /**
         * Reset assignments configuration to the previous saved configuration
         */
        undo() {
            this.assignmentsConf = { ...this.assignmentsConfCopy };
            this.$nextTick(() => {
                this.setUnsavedChanges(false);
            });
        },

        getOption(optionName, value) {
            return this[optionName].find(v => v.value === value) || [];
        },
    },
};
</script>
